import {
  ChangeDetectorRef,
  Component,
  computed,
  EventEmitter,
  forwardRef,
  inject,
  OnInit,
  Output,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FileService } from '@core/services/file-service/file.service';
import { SpeedikonService } from '@core/services/speedikon/speedikon.service';
import { TranslateModule } from '@ngx-translate/core';
import { DetailFileUploadComponent } from '@shared/components/details/detail-file-upload/detail-file-upload.component';
import { DocumentType, DocumentVisibility } from '@shared/types/document.types';
import { Observable } from 'rxjs';
import { OverrideModule } from '../../../../../../../app/override/override.module';
import { SharedModule } from '../../../../../../../app/shared/shared.module';

@Component({
  selector: 'app-speedikon-upload-modal',
  templateUrl: './speedikon-upload-modal.component.html',
  styleUrls: ['./speedikon-upload-modal.component.scss'],
  imports: [forwardRef(() => SharedModule), OverrideModule, TranslateModule],
})
export class SpeedikonUploadModalComponent
  extends DetailFileUploadComponent
  implements OnInit
{
  readonly data = inject(MAT_DIALOG_DATA);
  override readonly speedikonService = inject(SpeedikonService);
  override readonly fileService = inject(FileService);
  override readonly cd = inject(ChangeDetectorRef);
  readonly dialogRef = inject(MatDialogRef);

  override filteredTasks: Observable<string[]>;
  override documentVisibilities = this.fileService.documentVisibilities;
  override hasDocumentTypeSelection = false;
  override hasDocumentVisibilitySelection = false;

  @Output() uploadCompleted = new EventEmitter<void>();

  SpeedikonArchObjId = computed(() =>
    this.speedikonService.savedArchObjIdSignal()
  );

  override metadata: [{ attributeName: string; attributeValue: string }] = [
    {
      attributeName: 'SpeedikonArchObjId',
      attributeValue: this.SpeedikonArchObjId(),
    },
  ];

  override onTargetSystemSelected(event: any) {
    const selectedTargetSystem = this.targetSystems.find(
      (targetSystem: any) => targetSystem.label === event.option?.value
    );
    if (selectedTargetSystem) {
      this.defaultTargetSystemValue = selectedTargetSystem.value;
      this.defaultTargetSystemLabel = selectedTargetSystem.label;
    }
  }

  onUploadAndClose() {
    this.busy = true;
    this.uploadFiles(this.data?.document?.groupId).then(() => {
      this.busy = false;
      this.cd.markForCheck();
      this.uploadCompleted.emit();
      this.dialogRef.close();
    });
  }

  override ngOnInit(): void {
    this.defaultDocumentTypeValue = DocumentType.Bestandsplan;
    this.defaultDocumentVisibilityValue =
      DocumentVisibility.InternAndContractors;
  }
}
